
import * as cdnProviderRuntime$D9pXr8ZVP7 from '/Users/bdotzour/Development/thorne-site-nuxt/src/providers/cdn-provider.ts'
import * as ipxStaticRuntime$Pb5Uz7aT0f from '/Users/bdotzour/Development/thorne-site-nuxt/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cdnProvider']: { provider: cdnProviderRuntime$D9pXr8ZVP7, defaults: undefined },
  ['ipxStatic']: { provider: ipxStaticRuntime$Pb5Uz7aT0f, defaults: {} }
}
        